import { queryOptions, useQuery } from "@tanstack/react-query";
import { selfPlanSchema, type Plan } from "@/features/plans/schema";
import { apiFetch } from "@/lib/apiClient";

export type CurrentPlan = Pick<Plan, "id" | "name">;

export function currentPlanOptions(userId: string | undefined) {
  return queryOptions({
    queryKey: ["current-plan", userId],
    queryFn: async ({ signal }) => {
      const result = selfPlanSchema.safeParse(await apiFetch("/users/me/plan", { signal }));
      if (!result.success) throw new Error("The account plan response could not be read. Please retry.");
      return result.data;
    },
    enabled: Boolean(userId),
    staleTime: 60_000,
    gcTime: 0,
    retry: false,
  });
}

export function useCurrentPlan(userId: string | undefined) {
  return useQuery(currentPlanOptions(userId));
}
